module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "modal-ajout-conge el-dialog-header-blue",
    attrs: {
      "visible": _vm.visible
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      },
      "closed": _vm.hide
    }
  }, [_c('div', {
    staticClass: "modal-header-custom",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.modalTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body"
  }, [_c('div', {
    staticClass: "card-container"
  }, [_c('carte-conge-light', {
    attrs: {
      "typeConge": _vm.typeConges.NMoins1,
      "exercice": _vm.exercice
    }
  }), _vm._v(" "), _c('carte-conge-light', {
    attrs: {
      "typeConge": _vm.typeConges.N,
      "exercice": _vm.exercice
    }
  }), _vm._v(" "), _c('carte-conge-light', {
    attrs: {
      "typeConge": _vm.typeConges.Rtt,
      "exercice": _vm.exercice
    }
  })], 1), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (!_vm.dataIsReady),
      expression: "!dataIsReady"
    }],
    ref: "form",
    class: !_vm.dataIsReady ? 'blocked' : '',
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "120px",
      "element-loading-spinner": "el-icon-loading",
      "element-loading-background": "rgba(255, 255, 255, 0.8)"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Type d'absence",
      "prop": "selectedTypeConge",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "data-testid": "modalAjoutConge-filtre-liste-types-absences",
      "placeholder": "Type d'absence",
      "no-data-text": "Aucune absence disponible"
    },
    model: {
      value: (_vm.form.selectedTypeConge),
      callback: function($$v) {
        _vm.$set(_vm.form, "selectedTypeConge", $$v)
      },
      expression: "form.selectedTypeConge"
    }
  }, _vm._l((_vm.setTypesAbsenceFilter), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Période d'absence",
      "prop": "selectedDatesConge",
      "required": ""
    }
  }, [_c('el-date-picker', {
    ref: "rangeDatePicker",
    attrs: {
      "type": "daterange",
      "range-separator": "à",
      "format": "dd/MM/yyyy",
      "start-placeholder": "Date de début",
      "end-placeholder": "Date de fin",
      "picker-options": _vm.pickerOptions,
      "popper-class": "date-range-top-force"
    },
    on: {
      "change": _vm.checkPlageHoraire
    },
    model: {
      value: (_vm.form.selectedDatesConge),
      callback: function($$v) {
        _vm.$set(_vm.form, "selectedDatesConge", $$v)
      },
      expression: "form.selectedDatesConge"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "plage-horaire-container"
  }, [_c('el-form-item', {
    attrs: {
      "label": "Plage horaire (Début)",
      "prop": "plageDateDebut",
      "required": ""
    }
  }, [_c('el-radio', {
    attrs: {
      "disabled": _vm.isDisabledDebutMatin,
      "label": _vm.plageHoraire.matin,
      "border": ""
    },
    model: {
      value: (_vm.form.plageDateDebut),
      callback: function($$v) {
        _vm.$set(_vm.form, "plageDateDebut", $$v)
      },
      expression: "form.plageDateDebut"
    }
  }, [_vm._v("Matin")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "disabled": _vm.isDisabledDebutAprem,
      "label": _vm.plageHoraire.apresMidi,
      "border": ""
    },
    model: {
      value: (_vm.form.plageDateDebut),
      callback: function($$v) {
        _vm.$set(_vm.form, "plageDateDebut", $$v)
      },
      expression: "form.plageDateDebut"
    }
  }, [_vm._v("Après-midi")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Plage horaire (Fin)",
      "prop": "plageDateFin",
      "required": ""
    }
  }, [_c('el-radio', {
    attrs: {
      "disabled": _vm.isDisabledRadio || _vm.isDisabledFinMatin,
      "label": _vm.plageHoraire.matin,
      "border": ""
    },
    model: {
      value: (_vm.form.plageDateFin),
      callback: function($$v) {
        _vm.$set(_vm.form, "plageDateFin", $$v)
      },
      expression: "form.plageDateFin"
    }
  }, [_vm._v("Matin")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "disabled": _vm.isDisabledFinAprem,
      "label": _vm.plageHoraire.apresMidi,
      "border": ""
    },
    model: {
      value: (_vm.form.plageDateFin),
      callback: function($$v) {
        _vm.$set(_vm.form, "plageDateFin", $$v)
      },
      expression: "form.plageDateFin"
    }
  }, [_vm._v("Après-midi")])], 1)], 1), _vm._v(" "), (_vm.isPeriodeJours) ? _c('div', {
    staticClass: "nbr-jours-container"
  }, [_c('h3', {
    staticClass: "title-calcul"
  }, [_vm._v("Nombre de jours :")]), _vm._v(" "), _c('h3', {
    staticClass: "jours"
  }, [_vm._v(_vm._s(_vm.totalJours) + " j.")])]) : _c('div', {
    staticClass: "nbr-heures-container"
  }, [_c('h3', {
    staticClass: "title-calcul"
  }, [_vm._v("Nombre d'heures :")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "totalHeures",
      "error": _vm.totalHeuresError
    }
  }, [_c('el-input-number', {
    model: {
      value: (_vm.form.totalHeures),
      callback: function($$v) {
        _vm.$set(_vm.form, "totalHeures", $$v)
      },
      expression: "form.totalHeures"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.validateAndSubmit
    }
  }, [_vm._v("Valider")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.hide
    }
  }, [_vm._v("Annuler")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c51a364"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gestionDesAbsencesV2/modalAjoutConge/modalAjoutConge.vue.html
// module id = 5uvz
// module chunks = 2